export default {
  post: '新增',
  del: '删除',
  put: '修改',
  get: '查询'
}
